import { Component, forwardRef, Inject, Input } from '@angular/core';
import { BlockUI, NgBlockUI }                   from 'ng-block-ui';
import { NgbActiveModal }                       from '@ng-bootstrap/ng-bootstrap';

import { IntegrationQuotePricesModel }  from '../integrations/typings/integration.quote-prices';
import { MessagesService }              from '../messages/messages.service';
import { MobileService }                from './mobile.service';
import { MobileVideoMinutesQuoteModel } from './typings/mobile.video-minutes.quote';

@Component({
  selector   : 'mobile-video-minutes-purchase',
  template: require('./mobile.video-minutes-purchase.component.html')
})
export class MobileVideoMinutesPurchaseComponent {
  @BlockUI('videoMinutesBlock') block : NgBlockUI;

  @Input() cost: IntegrationQuotePricesModel;

  quote = {
    agree   : false,
    cost    : 0,
    quantity: 0
  } as MobileVideoMinutesQuoteModel;

  minimum = 1000;
  timeout: any;

  constructor (
    public  activeModal    : NgbActiveModal,
    @Inject(forwardRef(() => MessagesService)) private messagesService: MessagesService,
    @Inject(forwardRef(() => MobileService))
    private mobileService  : MobileService
  ) {}

  confirm () : void {
    this.block.start();

    this.mobileService.confirmVideoMinutesPurchase(this.quote)
    .then(() => {
      this.activeModal.close();
    })
    .catch(( err ) => {
      this.messagesService.error(err);
    })
    .finally(() => {
      this.block.stop();
    });
  }

  getQuote () : void {
    if ( this.timeout ) {
      clearTimeout(this.timeout);
    }

    if ( this.quote.quantity >= this.minimum ) {
      this.timeout = setTimeout(() => {
        this.block.start();

        this.mobileService.getVideoMinutesQuote(this.quote)
        .then(( quote : MobileVideoMinutesQuoteModel ) => {
          this.quote = quote;
        })
        .finally(() => {
          this.block.stop();
        });
      }, 500);
    }
    else {
      this.quote.cost = 0;
    }
  }
}
